<template>
    <div class="flex-level jc-center hp-10">
        <div class="flex-column ai-center">
            <img src="/ressources/logged/img/onboarding/email/cup.png" class="  " />
            <h2 class="mb-0 mt-5">{{ $l10n.__('Tout est bon !') }}</h2>
            <p class="mb-4 mt-3 w-5 acenter fs-3">
                {{
                    $l10n.__(
                        'Vous pouvez désormais utiliser l’ensemble des fonctionnalités %(provider)s directement depuis Sellsy',
                        { provider: nameProvider },
                    )
                }}
            </p>
            <CompassButton
                :label="$t.__('common.actions.continue')"
                type="primary"
                @click="goToContext()"
            />
        </div>
    </div>
</template>

<script>
import Feature from 'Services/Feature';

export default {
    name: 'OnboardingEmailFinal',
    computed: {
        /**
         * Return the name of the Provider chosen by user
         */
        nameProvider() {
            return this.$attrs.provider ? this.$attrs.provider.title : '';
        },
        /**
         * Return context where user start onboarding or route of email listing
         */
        context() {
            return this.$attrs.context
                ? decodeURIComponent(this.$attrs.context)
                : '/emails/redirect/to-email-box';
        },
    },
    methods: {
        /**
         * Redirect to email listing or context of user
         *
         */
        goToContext() {
            window.location.href = Feature.isEnabled('email-engine')
                ? '/settings/email?status=true'
                : this.context;
        },
    },
};
</script>

<style lang="scss" scoped>
h2 {
    line-height: 24px;
}
p {
    line-height: 17px;
}
</style>
